/* eslint-disable tailwindcss/no-custom-classname -- to refactor later */
import { useFormContext, useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";
import { PaywallSpaceAccessManagement } from "./PaywallSpaceAccessManagement";
import "./style.scss";

export const AccessContent = () => {
  const { control } = useFormContext();
  const allSpacesToggleWatcher = useWatch({ control, name: "all_spaces" });

  return (
    <div
      className={classNames(
        "paywalls-admin-drawer-access-tab__container flex min-h-[40vh] flex-col gap-y-4 pb-4",
      )}
    >
      <Form.Item
        className={classNames(
          "!mt-0 flex flex-row-reverse items-center gap-x-4 !py-0",
        )}
        name="all_spaces"
        translationRoot="settings.paywalls.modal.tabs.access"
        tooltipText={t(
          "settings.paywalls.modal.tabs.access.all_spaces_tooltip",
        )}
        inline
        hideBorder
        hideDescription
      >
        <Form.ToggleSwitch name="all_spaces" variant="small" />
      </Form.Item>
      {!allSpacesToggleWatcher && <PaywallSpaceAccessManagement />}
      {allSpacesToggleWatcher && (
        <div className="flex size-full flex-auto flex-col items-center justify-center gap-y-3 text-center">
          <Typography.TitleSm color="text-selector-active" weight="semibold">
            {t("settings.paywalls.modal.tabs.access.all_access_title")}
          </Typography.TitleSm>
          <Typography.LabelSm color="text-selector-active">
            {t("settings.paywalls.modal.tabs.access.all_access_subtitle")}
          </Typography.LabelSm>
        </div>
      )}
    </div>
  );
};
